import * as React from "react";
import {
  TextField,
  NumberField,
  Labeled,
  useTranslate,
  FunctionField,
  TabbedShowLayout,
} from "react-admin";
import { ColorField } from "react-admin-color-picker";

const TextBlockFields = () => {
  const t = useTranslate();

  return (
    <TabbedShowLayout.Tab label="">
      <Labeled label="resources.Block.fields.props.text">
        <TextField source="props.text" />
      </Labeled>
      <Labeled label="resources.Block.fields.styles.color">
        <ColorField source="styles.color" />
      </Labeled>
      <Labeled label="resources.Block.fields.styles.fontWeight">
        <NumberField source="styles.fontWeight" />
      </Labeled>
      <Labeled label="resources.Block.fields.styles.fontSize">
        <NumberField source="styles.fontSize" />
      </Labeled>
      <Labeled label="resources.Block.fields.styles.textAlign">
        <FunctionField
          source="styles.textAlign"
          render={(record) => t(`textAlign.${record.styles.textAlign}`)}
        />
      </Labeled>
      <Labeled label="resources.Block.fields.styles.fontStyle">
        <FunctionField
          source="styles.fontStyle"
          render={(record) => t(`fontStyle.${record.styles.fontStyle}`)}
        />
      </Labeled>
    </TabbedShowLayout.Tab>
  );
};

export default TextBlockFields;
